'use strict';

let module = {};

(function (module) {

    var routes = function ($stateProvider, baseState) {

        $stateProvider

            .state('' + baseState + '.clerk-tax-entities', {
                abstract: true,
                url: "/tax-entities",
                template: "<ui-view/>"
            })

            ;

        var views = {};
        views['@' + baseState + '.clerk-tax-entities'] = {
            template: require("crud/clerk-tax-entity/list.html"),
            controller: "listClerkTaxEntitiesController",
        };

        $stateProvider

            .state('' + baseState + '.clerk-tax-entities.list', {
                url: "/list",
                views: views,
                data: {pageTitle: 'List Tax Entities'}
            })

            ;

        var views = {};
        views['@' + baseState + '.clerk-tax-entities'] = {
            template: "<ui-view/>",
            controller: "listClerkTaxEntitiesController",
        };

        $stateProvider

            .state('' + baseState + '.clerk-tax-entities.curate', {
                abstract: true,
                url: "/curate",
                views: views,
                data: {pageTitle: 'Curate Tax Entities'}
            })

            // Add initial alias for "first-step" TODO: Refactor to have dynamic step logic in angular logic instead of repeated code
            .state('' + baseState + '.clerk-tax-entities.curate.continue-editing', {
                url: "/continue-editing",
                data: {
                    pageTitle: 'Curate Tax Entity - Step \'attributes\'',
                    stepCaption: "Attributes",
                    stepMetadata: {"stepReference":"attributes","step":"attributes"},
                },
                template: require("crud/clerk-tax-entity/curate-steps/attributes.html"),
                controller: "listClerkTaxEntitiesController",
                resolve: {
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        routeBasedVisibilitySettings.ClerkTaxEntity_columns_by_step = 'attributes';
                    },
                }
            })

            // "Attributes"
            .state('' + baseState + '.clerk-tax-entities.curate.attributes', {
                url: "/attributes",
                data: {
                    pageTitle: 'Curate Tax Entity - Step \'attributes\'',
                    stepCaption: "Attributes",
                    stepMetadata: {"stepReference":"attributes","step":"attributes"},
                },
                template: require("crud/clerk-tax-entity/curate-steps/attributes.html"),
                controller: "listClerkTaxEntitiesController",
                resolve: {
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        routeBasedVisibilitySettings.ClerkTaxEntity_columns_by_step = 'attributes';
                    },
                }
            })


            .state('' + baseState + '.clerk-tax-entities.create', {
                url: "/new",
                onEnter: /*@ngInject*/ function ($state, clerkTaxEntity, clerkTaxEntities) {
                    let itemAttributes = {
                        'attributes': {
                        }
                    };
                    clerkTaxEntities.add(itemAttributes, function (createdItem) {
                        let goToStateParams = angular.merge($state.params, {activeClerkTaxEntityId: createdItem.id});
                        $state.transitionTo(
                            '' + baseState + '.clerk-tax-entities.existing.edit.continue-editing',
                            goToStateParams,
                            {location: 'replace', inherit: true, relative: $state.$current, notify: true}
                        );
                    });
                },
                data: {pageTitle: 'New Tax Entity'}
            })

            .state('' + baseState + '.clerk-tax-entities.existing', {
                abstract: true,
                url: "/:activeClerkTaxEntityId",
                resolve: {
                    setRouteBasedContentFiltersLevel0: /*@ngInject*/ function (routeBasedContentFilters, $stateParams) {
                        // TODO: Generate the following dynamically based on data model
                        routeBasedContentFilters.Bar_order = 'Foo.id DESC';
                        routeBasedContentFilters.Bar_foo_id = $stateParams.fooId;
                    },
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        // TODO: Adjust the below so that columns that are all the same value due to a route-based filter are hidden
                        routeBasedVisibilitySettings.ClerkTaxEntity_hide_source_relation = 'ClerkTaxEntity';
                    },
                    currentClerkTaxEntity: /*@ngInject*/ function ($stateParams, clerkTaxEntity) {
                        let activeClerkTaxEntityId = $stateParams.activeClerkTaxEntityId;
                        clerkTaxEntity.$activate();
                        return clerkTaxEntity.load(activeClerkTaxEntityId);
                    },
                },
                template: "<ui-view/>"
            })

            /*
             .state('' + baseState + '.clerk-tax-entities', {
             url: "/dashboard",
             template: require("crud/clerk-tax-entity/dashboard.html"),
             data: {pageTitle: 'Tax Entities Dashboard'}
             })
             */

            ;

        var views = {};
        views['@' + baseState + '.clerk-tax-entities'] = {
            controller: "editClerkTaxEntityController",
            template: require("crud/clerk-tax-entity/view.html"),
        };

        $stateProvider

            .state('' + baseState + '.clerk-tax-entities.existing.view', {
                url: "/view",
                views: views,
                data: {pageTitle: 'View Tax Entity'}
            })


            ;

        var views = {};
        views['@' + baseState + '.clerk-tax-entities'] = {
            controller: "editClerkTaxEntityController",
            template: require("crud/clerk-tax-entity/components/form.html")
        };
        /*
        views['sidebar@root'] = {
            template: require("crud/clerk-tax-entity/navigation.html")
        };
        */

        $stateProvider

            .state('' + baseState + '.clerk-tax-entities.existing.edit', {
                abstract: true,
                url: "/edit",
                views: views,
                data: {
                    showSideMenu: true,
                    pageTitle: 'Edit Tax Entity'
                }
            })

            // Add initial alias for "first-step" TODO: Refactor to have dynamic step logic in angular logic
            .state('' + baseState + '.clerk-tax-entities.existing.edit.continue-editing', {
                url: "/continue-editing",
                template: require("crud/clerk-tax-entity/steps/attributes.html"),
                data: {pageTitle: 'Edit Tax Entity'}
            })

            // "Attributes"
            .state('' + baseState + '.clerk-tax-entities.existing.edit.attributes', {
                url: "/attributes",
                template: require("crud/clerk-tax-entity/steps/attributes.html"),
                data: {
                    pageTitle: 'Edit Tax Entity - Step \'attributes\'',
                    stepCaption: "Attributes",
                    stepMetadata: {"stepReference":"attributes","step":"attributes"},
                }
            })

            .state('' + baseState + '.clerk-tax-entities.existing.edit.attributes.attributes', {
                abstract: true,
                template: "<ui-view/>"
            })

            // "id" TYPE primary-key TODO scrollto/mark -->

            // "remote_source_tag_spec" TYPE ordinary TODO scrollto/mark -->

            // "ordinal" TYPE ordinary TODO scrollto/mark -->

            // "label" TYPE ordinary TODO scrollto/mark -->

            // "key_combo" TYPE ordinary TODO scrollto/mark -->

            // "clerkTaxEntityType" TYPE has-one-relation TODO scrollto/mark -->

            // "clerkTaxRegion" TYPE has-one-relation TODO scrollto/mark -->

            // "correspondingHumanAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "correspondingEntity" TYPE has-one-relation TODO scrollto/mark -->

            // "started_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "ended_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "is_started" TYPE ordinary TODO scrollto/mark -->

            // "is_ended" TYPE ordinary TODO scrollto/mark -->

            // "ignore_source_material_earlier_than_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "ignore_source_material_later_than_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "since" TYPE ordinary TODO scrollto/mark -->

            // "vat_no" TYPE ordinary TODO scrollto/mark -->

            // "reg_no" TYPE ordinary TODO scrollto/mark -->

            // "aliases" TYPE ordinary TODO scrollto/mark -->

            // "correspondingSqMerchant" TYPE has-one-relation TODO scrollto/mark -->

            // "knowledge_of_internals_expected" TYPE ordinary TODO scrollto/mark -->

            // "uses_custom_chart_of_accounts" TYPE ordinary TODO scrollto/mark -->

            // "seSpPrivateEquityClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seSpPrivateDepositsClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seSpPrivateWithdrawalsClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seLcRetainedEarningsClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seSalesClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "sePurchasesClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seAccountsReceivableClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seAccountsPayableClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seUnreducedVatOnPurchasesClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seUnreducedVatOnSalesClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seUnreducedVatOnPurchasesRevChargeClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seUnreducedVatOnSalesRevChargeClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seReduced1VatOnPurchasesClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seReduced1VatOnSalesClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seReduced1VatOnPurchasesRevChargeClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seReduced1VatOnSalesRevChargeClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seReduced2VatOnPurchasesClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seReduced2VatOnSalesClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seReduced2VatOnPurchasesRevChargeClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seReduced2VatOnSalesRevChargeClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seTravelAllowancesClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seTravelExpensesClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seExpenseAccountClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "sePremiseCostsClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seFiscalYearEarnings89ClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seInventoryDepreciationsClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seInventoryClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seAnticipatedAuditExpenseClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seAuditExpenseClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "sePrimaryOwnerClearanceAccountClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seLcAnticipatedIncomeTaxClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seLcFiscalYearIncomeTaxClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seFiscalYearEarningsClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seFiscalYearVatClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "seAmountRoundingClerkLedgerAccount" TYPE has-one-relation TODO scrollto/mark -->

            // "economacs_uid" TYPE ordinary TODO scrollto/mark -->

            // "economacsFile" TYPE has-one-relation TODO scrollto/mark -->

            // "clerkDataset" TYPE internal TODO scrollto/mark -->

            // "node" TYPE internal TODO scrollto/mark -->

            // "owner" TYPE internal TODO scrollto/mark -->

            // "most_recent_interpretation_of_clue_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "created" TYPE ordinary TODO scrollto/mark -->

            // "modified" TYPE ordinary TODO scrollto/mark -->

            // "interpretation" TYPE internal TODO scrollto/mark -->



        ;

    };

    module.routes = routes;

    /*
     Usage example:
     someAngularModuleThatRequiresThisItemsCrudRouting.config(function ($stateProvider) {
         routes($stateProvider, 'root.api-endpoints.existing');
     });
     */

})(module);

export default module;



// WEBPACK FOOTER //
// .-dna/app/crud/clerk-tax-entity/routes.js